//
//
//
//
//
//
//
//
//
//

import gql from 'graphql-tag';

export default {
  props: {
    contentUuid: String,
    contentType: String,
    siteUuid: String,
    parentUuid: String,
    endpoint: String,
    client: Object, // Instantiated apollo client.
    authorUuid: String,
  },
  data() {
    const data = {
      commentInput: null,
      contentUuid: this.contentUuid,
      contentType: this.contentType,
      parentUuid:  this.parentUuid ? this.parentUuid : null,
      disabled: false,
      authorUuid: this.authorUuid ? this.authorUuid : null,
    };

    return data;
  },
  methods: {
    postComment(e) {
      e.preventDefault();
      this.disabled = true;
      this.postToApi(this.commentInput)
      this.commentInput = null;
    },
    postToApi(body) {
      this.client.mutate({
        mutation: gql`
          mutation CommentOnContent(
            $contentUuid: UUID!,
            $contentType: ContentType!,
            $siteUuid: UUID!,
            $body: String!,
            $parentUuid: UUID,
            $authorUuid: UUID
          ) {
            addComment(
              contentUuid: $contentUuid,
              contentType: $contentType,
              siteUuid: $siteUuid,
              body: $body,
              parentUuid: $parentUuid,
              authorUuid: $authorUuid
            ) {
              comment {
                uuid
                body
                created
                authorUuid
                author {
                  firstName
                  lastName
                  displayName
                  avatar
                }
              }
            }
          }
        `,
        variables: {
          body,
          contentUuid: this.contentUuid,
          contentType: this.contentType,
          siteUuid: this.siteUuid,
          parentUuid: this.parentUuid,
          authorUuid: this.authorUuid,
        }
      }).then(result => {
        this.$emit('new-comment', {
          comment: result.data.addComment.comment,
        });
        this.disabled = false;
      }).catch(error => {
        console.log(error);
      })
    },
  },
}



// WEBPACK FOOTER //
// ./app/components/molecules/comment-form/comment-form.vue